import React, { useEffect, useRef } from 'react'
import lottie from 'lottie-web';
import { Helmet } from "react-helmet";

const SubLoading = () => {
    const aniCont = useRef(null);
    
    useEffect(() => {
       lottie.loadAnimation({
           container: aniCont.current,
           renderer: 'svg',
           loopL: true,
           autoplay: true,
           animationData: require('../../assets/Animations/9329-loading.json')
       })
    }, []);

    return ( 
        <>
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic is Registered with the Ministry of Higher And Tertiary Education, Science and Technology Development."
                />
                <title>Loading...</title>
            </Helmet>
            <div className="container">
                <div className="sub-loading-cont">
                    <div className="animation" ref={aniCont}></div>
                </div>
            </div>
        </>

     );
}
 
export default SubLoading;